import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as PermissionsActions from './permissions.actions';
import { RolesService } from '@boma/supplier-portal/shared/services';

@Injectable()
export class PermissionsEffects {
  getTargetPermissions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PermissionsActions.getTargetPermissions),
      concatMap(({ payload }) =>
        this.rolesService.getTargetPermissions(payload).pipe(
          map((res) =>
            PermissionsActions.getTargetPermissionsSuccess({
              target: payload,
              payload: res,
            })
          ),
          catchError((error) =>
            of(PermissionsActions.getTargetPermissionsFailure({ error }))
          )
        )
      )
    );
  });

  constructor(private actions$: Actions, private rolesService: RolesService) {}
}
